import {useNavigate} from "react-router-dom";
import {useState} from "react";
import Swal from "sweetalert2";
import {AuthService} from "./services/AuthService";
import {NewLoading} from "./components/NewLoading";

const ForgotPassword = () => {
    const [step, setStep] = useState(1);

    const [email, setEmail] = useState("");
    const [resetCode, setResetCode] = useState("");

    const navigate = useNavigate();

    const [sendEmailLoading, setSendEmailLoading] = useState(false);

    const handleSendEmailBtnClick = async () => {

        if (email === "") {
            Swal.fire({
                title: "", icon: "info", text: "Não inseriu um endereço de e-mail"
            });
            return;
        }

        setSendEmailLoading(true);
        try {

            const response = await AuthService().sendForgotEmail(email);
            await Swal.fire({
                title: "", icon: "success", text: response.data.message
            });

            setStep(2);
        } catch (e) {
            Swal.fire({
                title: "", icon: "warning", text: e.response.data.message
            });
        }
        setSendEmailLoading(false);
    };

    const handleResetPassword = async () => {

        if (resetCode == null) {
            Swal.fire({
                icon: "info",
                text: "Por favor insira o código",
                title: ""
            });
            return;
        }

        try {
            const response = await AuthService().isValidToken(email, resetCode);
            navigate(`/resetPassword?email=${email}&token=${resetCode}`);
        } catch (e) {
            Swal.fire({
                icon: "error",
                text: "Código incorreto!",
                title: ""
            });
        }
    }

    return (<div className={"flex items-center justify-center p-4 forgotpassword-page"}>
            <div className="forgot-password-container bg-white w-full max-w-4xl">
                <div className="flex flex-col md:flex-row">
                    <div className="w-full md:w-1/2 p-8 flex flex-col">
                        <div className="flex items-center mb-8">
                            <div className="w-16 h-16 bg-blue-500 rounded-lg flex items-center justify-center mr-4">
                                <i className="fas fa-key text-white text-2xl"></i>
                            </div>
                            <h1 className="text-3xl font-bold text-gray-800">DDtank <span
                                className="text-blue-500">Splush</span></h1>
                        </div>

                        <div className="flex-1 flex items-center">
                            <div className="w-full">

                                {step === 1 ? (<>
                                        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Redefinir
                                            senha</h2>
                                        <p className="text-gray-600 mb-6">Digite o e-mail associado à sua conta e
                                            enviaremos um
                                            link para redefinir sua senha.</p>

                                        <form id="resetRequestForm" className="space-y-4">
                                            <div>
                                                <label htmlFor="email"
                                                       className="block text-sm font-medium text-gray-700 mb-1">E-mail
                                                    da conta</label>
                                                <div className="relative">
                                                    <div
                                                        className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                        <i className="fas fa-envelope text-gray-400"></i>
                                                    </div>
                                                    <input type="email" id="email" value={email}
                                                           onChange={(e) => setEmail(e.target.value)}
                                                           className="forgot-password-input-field pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                                                           placeholder="seu@email.com" required/>
                                                </div>
                                            </div>

                                            {!sendEmailLoading ? (
                                                <button type="button" onClick={() => handleSendEmailBtnClick()}
                                                        className="forgot-password-btn-login w-full py-3 px-4 text-white font-medium rounded-lg animation-pulse">
                                                    <i className="fas fa-paper-plane mr-2"></i> Enviar link de
                                                    redefinição
                                                </button>) : (<button type="button"
                                                                      className="forgot-password-btn-login w-full py-3 px-4 text-white font-medium rounded-lg disabled">
                                                    Enviando...
                                                </button>)}

                                            <div className="text-center pt-4">
                                                <a href="#" onClick={() => navigate('/')}
                                                   className="text-blue-500 hover:text-blue-700 text-sm flex items-center justify-center">
                                                    <i className="fas fa-arrow-left mr-2"></i> Voltar para o login
                                                </a>
                                            </div>
                                        </form>
                                    </>) : (
                                    <>
                                        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Segurança</h2>

                                        <p className="text-gray-600 mb-6">Digite o código que enviamos para <span
                                            className="font-medium">{email}</span> para continuar.</p>

                                        <form id="resetRequestForm" className="space-y-4">
                                            <div>
                                                <label htmlFor="email"
                                                       className="block text-sm font-medium text-gray-700 mb-1">Código</label>
                                                <div className="relative">
                                                    <div
                                                        className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                        <i className="fas fa-key text-gray-400"></i>
                                                    </div>
                                                    <input type="resetCode" id="resetCode" value={resetCode}
                                                           onChange={(e) => setResetCode(e.target.value)}
                                                           className="forgot-password-input-field pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                                                           placeholder="Insira o código" required/>
                                                </div>
                                            </div>

                                            {!sendEmailLoading ? (
                                                <button type="button" onClick={() => handleResetPassword()}
                                                        className="forgot-password-btn-login w-full py-3 px-4 text-white font-medium rounded-lg">
                                                    Redefinir senha
                                                </button>) : (<button type="button"
                                                                      className="forgot-password-btn-login w-full py-3 px-4 text-white font-medium rounded-lg disabled">
                                                Verificando...
                                            </button>)}

                                            <div className="text-center pt-4">
                                                <a href="#" onClick={() => setStep(1)}
                                                   className="text-blue-500 hover:text-blue-700 text-sm flex items-center justify-center">
                                                    <i className="fas fa-arrow-left mr-2"></i> Voltar
                                                </a>
                                            </div>
                                        </form>
                                    </>
                                )}

                            </div>
                        </div>

                    </div>

                    <div className={`w-full md:w-1/2 bg-gray-50 p-8 flex flex-col items-center justify-center ${step !== 1 ? "hidden" : ""}`}>
                        <div className="text-center mb-8">
                            <div className="envelope-icon inline-block bg-blue-100 text-blue-500 p-6 rounded-full mb-4">
                                <i className="fas fa-envelope-open-text text-4xl"></i>
                            </div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-2">O que acontece depois?</h3>
                            <p className="text-gray-600">Você receberá um e-mail com código para seguir a redefinição.</p>
                        </div>

                        <div className="w-full max-w-xs">
                            <div className="space-y-4">
                                <div className="flex items-start">
                                    <div className="bg-blue-100 text-blue-500 p-2 rounded-full mr-3 mt-1">
                                        <i className="fas fa-check-circle"></i>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">Verifique sua caixa de entrada</h4>
                                        <p className="text-sm text-gray-600 mt-1">O e-mail pode levar alguns minutos
                                            para chegar.</p>
                                    </div>
                                </div>

                                <div className="flex items-start">
                                    <div className="bg-blue-100 text-blue-500 p-2 rounded-full mr-3 mt-1">
                                        <i className="fas fa-check-circle"></i>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">Verifique a pasta de spam</h4>
                                        <p className="text-sm text-gray-600 mt-1">Caso não encontre, verifique sua pasta
                                            de spam/lixo eletrônico.</p>
                                    </div>
                                </div>

                                <div className="flex items-start">
                                    <div className="bg-blue-100 text-blue-500 p-2 rounded-full mr-3 mt-1">
                                        <i className="fas fa-check-circle"></i>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">Código expira em 24 horas</h4>
                                        <p className="text-sm text-gray-600 mt-1">Por segurança, o código de redefinição
                                            expira após 24 horas.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-8 text-center">
                                <p className="text-sm text-gray-500">Problemas com o e-mail? <a
                                    href={process.env.REACT_APP_HELP_LINK} target={"_blank"}
                                    className="text-blue-500 hover:text-blue-700">Entre
                                    em contato com o suporte</a></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-gray-800 text-white px-6 py-4 text-center text-sm">
                    <p>DDtank Splush © 2025 Todos os direitos reservados</p>
                    <div className="flex justify-center space-x-4 mt-2">
                        <a href="#" className="hover:text-blue-300"><i className="fab fa-facebook"></i></a>
                        <a href="#" className="hover:text-blue-400"><i className="fab fa-twitter"></i></a>
                        <a href="#" className="hover:text-red-400"><i className="fab fa-youtube"></i></a>
                        <a href="#" className="hover:text-purple-400"><i className="fab fa-discord"></i></a>
                    </div>
                </div>
            </div>
        </div>);
};

export default ForgotPassword;